import React from 'react'
import PropTypes from 'prop-types'
import fuzzysearch from 'fuzzysearch'
import i18n from 'i18next'
import {get} from 'lodash-es'
import {chunk, buildRangeArray} from '../Services/helpers.jsx'
import {Check, Close, Plus, Search} from '../Icons/index.jsx'

export default class Dropdown extends React.Component {
  static defaultProps = {
    className: '',
    onClose: Function.prototype,
    onSelect: Function.prototype,
    onToggleOption: Function.prototype,
    options: [],
    activeOptions: [],
    listRef: {},
    onSearchBarFocus: Function.prototype,
    isMultipleSelect: false,
    optionsSelectedCopySingular: Function.prototype,
    optionsSelectedCopyPlural: Function.prototype,
    resetSelectedOptions: Function.prototype,
  }

  static propTypes = {
    className: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    activeOption: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    ]),
    activeOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    showSearchBar: PropTypes.bool,
    onSelect: PropTypes.func,
    onToggleOption: PropTypes.func,
    listRef: PropTypes.any,
    onSearchBarFocus: PropTypes.func,
    isMultipleSelect: PropTypes.bool,
    mostPopularOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    optionsSelectedCopySingular: PropTypes.func,
    optionsSelectedCopyPlural: PropTypes.func,
    resetSelectedOptions: PropTypes.func,
    callbackActionLabel: PropTypes.string,
    callbackActionOnClick: PropTypes.func,
    onClose: PropTypes.func,
  }

  state = {
    queryFilter: '',
    highlightedOption: undefined,
  }

  constructor() {
    super()
    this.textInput = React.createRef()
  }

  get onMouseDown() {
    return this.props.isMultipleSelect
      ? this.props.onToggleOption
      : this.props.onSelect
  }

  getFilteredOptionsInColumns = () => {
    const {options} = this.props
    const optionsPerColumn = Math.ceil(options.length / 4)
    const filteredOptionsInColumns = chunk(
      this.filteredOptions(),
      optionsPerColumn,
    )

    if (filteredOptionsInColumns.length >= 4) {
      return filteredOptionsInColumns
    } else {
      return filteredOptionsInColumns.concat(
        buildRangeArray(4 - filteredOptionsInColumns.length).map(function () {
          return []
        }),
      )
    }
  }

  getOptionsSelectedCopy = () => {
    const {
      optionsSelectedCopySingular,
      optionsSelectedCopyPlural,
      activeOptions,
    } = this.props
    if (optionsSelectedCopySingular && optionsSelectedCopyPlural) {
      const optionsSelectedLength = activeOptions ? activeOptions.length : 0
      return optionsSelectedLength === 1
        ? optionsSelectedCopySingular(optionsSelectedLength)
        : optionsSelectedCopyPlural(optionsSelectedLength)
    } else {
      return ''
    }
  }

  filteredOptions = (filter = null) => {
    //todo: refactoring this section. remove if filter and optimize.
    const {queryFilter, itemsOnTop} = this.state
    const {options} = this.props
    const filteredOptions = options.filter((option) => {
      return !!option.id
    })

    if (filter) {
      const lowerQueryFilter = filter.toLowerCase()
      return filteredOptions
        .filter((option) => {
          return (
            fuzzysearch(lowerQueryFilter, option.name.toLowerCase()) ||
            fuzzysearch(lowerQueryFilter, option.id)
          )
        })
        .sort((optionA, optionB) => {
          const queryPositionInOptionA = optionA.name
            .toLowerCase()
            .indexOf(lowerQueryFilter)
          const queryPositionInOptionB = optionB.name
            .toLowerCase()
            .indexOf(lowerQueryFilter)
          const queryPositionInOptionANormalized =
            queryPositionInOptionA > -1 ? queryPositionInOptionA : 1000
          const queryPositionInOptionBNormalized =
            queryPositionInOptionB > -1 ? queryPositionInOptionB : 1000
          return queryPositionInOptionANormalized >
            queryPositionInOptionBNormalized
            ? 1
            : -1
        })
    } else if (queryFilter && queryFilter.length) {
      const lowerQueryFilter = queryFilter.toLowerCase()
      return filteredOptions
        .filter((option) => {
          return (
            fuzzysearch(lowerQueryFilter, option.name.toLowerCase()) ||
            fuzzysearch(lowerQueryFilter, option.id)
          )
        })
        .sort((optionA, optionB) => {
          const queryPositionInOptionA = optionA.name
            .toLowerCase()
            .indexOf(lowerQueryFilter)
          const queryPositionInOptionB = optionB.name
            .toLowerCase()
            .indexOf(lowerQueryFilter)
          const queryPositionInOptionANormalized =
            queryPositionInOptionA > -1 ? queryPositionInOptionA : 1000
          const queryPositionInOptionBNormalized =
            queryPositionInOptionB > -1 ? queryPositionInOptionB : 1000
          return queryPositionInOptionANormalized >
            queryPositionInOptionBNormalized
            ? 1
            : -1
        })
    } else {
      let standardOptions = []
      const activeOptions = itemsOnTop || []
      const onTopOptions = filteredOptions.filter((option) => {
        const isActiveOptions =
          activeOptions.filter((activeOption) => {
            return activeOption.id === option.id
          }).length > 0
        const isOnTop = !!isActiveOptions
        if (isOnTop) {
          return true
        } else {
          standardOptions.push(option)
          return false
        }
      })
      return onTopOptions.concat(standardOptions)
    }
  }

  UNSAFE_componentWillUpdate = (nextProps) => {
    if (this.props.isMultipleSelect !== nextProps.isMultipleSelect) {
      setTimeout(() => {
        this.textInput.current.focus()
      }, 0)
    }
  }

  componentDidMount = () => {
    const {showSearchBar, activeOptions} = this.props
    if (showSearchBar) {
      document.addEventListener(
        'keydown',
        this.navigateDropdownSelectedWithArrows,
      )
      this.textInput.current.focus()
    }
    this.setState({itemsOnTop: activeOptions})
  }

  componentWillUnmount = () => {
    document.removeEventListener(
      'keydown',
      this.navigateDropdownSelectedWithArrows,
    )
  }

  scrollDropDownToTop = () => {
    const textInputElement = this.textInput && this.textInput.current
    const dropDownElement =
      textInputElement && get(textInputElement, 'parentElement.parentElement')
    const dropDownListElement =
      dropDownElement && dropDownElement.querySelector('.dropdown__list')

    if (dropDownListElement) {
      setTimeout(function () {
        dropDownListElement.scrollTop = 0
      }, 0)
    }
  }

  updateQueryFilter = (event) => {
    const highlightedOption = this.filteredOptions(event.target.value)[0]
    this.setState(
      {
        queryFilter: event.target.value,
        highlightedOption: highlightedOption,
      },
      this.scrollDropDownToTop,
    )
  }

  renderOption = (option, index) => {
    const {highlightedOption} = this.state
    const {activeOptions, activeOption} = this.props
    const isHighlightedOption = highlightedOption
      ? option.id === highlightedOption.id
      : false
    const currentActiveOptions = activeOptions || []
    const isActiveOption =
      option.id === (activeOption ? activeOption.id : undefined)
    const isActiveOptions =
      currentActiveOptions.filter((activeOption) => {
        return activeOption.id === option.id
      }).length > 0
    const isNoResultsFound = option.id === 'noResultsFound'
    const showActiveOptionIcon = isActiveOption || isActiveOptions
    const showHighlightedOptionIcon = !isActiveOption && !isActiveOptions

    return (
      <li
        className={`dropdown__option ${
          isActiveOption || isActiveOptions
            ? 'dropdown__option--is-active-option'
            : ''
        } ${
          isHighlightedOption ? 'dropdown__option--is-highlighted-option' : ''
        } ${isNoResultsFound ? 'dropdown__option--is-no-results-found' : ''}`}
        key={index}
        onMouseDown={
          isNoResultsFound ? Function.prototype : () => this.onMouseDown(option)
        }
      >
        <span>{option.name}</span>
        {showActiveOptionIcon && (
          <Check
            className={'dropdown__active-option-icon'}
            onMouseDown={e => {
              e.stopPropagation();
              this.onMouseDown(option);
            }}
          />
        )}
        {showHighlightedOptionIcon && (
          <Plus
            className={'dropdown__highlighted-option-icon'}
            onMouseDown={e => {
              e.stopPropagation();
              this.onMouseDown(option);
            }}
          />
        )}
      </li>
    )
  }

  renderMostPopularOption = (option, index) => {
    const isOptionSelected =
      this.props.activeOptions &&
      this.props.activeOptions.filter(function (activeOption) {
        return option.id === activeOption.id
      }).length > 0
    return (
      <span
        className={`dropdown__most-popular-option link${
          isOptionSelected ? ' dropdown__most-popular-option--selected' : ''
        }`}
        key={index}
        onMouseDown={() => this.onMouseDown(option)}
      >
        {option.name}
      </span>
    )
  }
  /* keyboard navigation */
  navigateDropdownSelectedWithArrows = (event) => {
    const {highlightedOption} = this.state
    const {activeOption, onToggleOption, isMultipleSelect, onSelect} =
      this.props
    const keyCode = event.keyCode
    const previousHighlightedOption = highlightedOption || activeOption
    const previousHighlightedOptionIndex = this.filteredOptions().reduce(
      (highlightedOptionIndex, currentOption, index) => {
        const previousHighlightedOptionId = previousHighlightedOption
          ? previousHighlightedOption.id
          : undefined
        return currentOption.id === previousHighlightedOptionId
          ? index
          : highlightedOptionIndex
      },
      0,
    )
    const optionsPerColumn = Math.ceil(this.props.options.length / 4)

    if (keyCode === 38) {
      // up key
      const nextHighlightedOptionIndex =
        previousHighlightedOptionIndex > 0
          ? previousHighlightedOptionIndex - 1
          : 0
      const nextHighlightedOption = this.filteredOptions().filter(
        (option, index) => {
          return index === nextHighlightedOptionIndex
        },
      )[0]

      this.setState(
        {
          highlightedOption:
            nextHighlightedOption && nextHighlightedOption.id
              ? nextHighlightedOption
              : previousHighlightedOption,
        },
        this.scrollToHighlightedOptionIfNotVisible,
      )
    } else if (keyCode === 40) {
      // down key
      const nextHighlightedOptionIndex =
        previousHighlightedOptionIndex < this.filteredOptions().length
          ? previousHighlightedOptionIndex + 1
          : this.filteredOptions().length - 1
      const nextHighlightedOption = this.filteredOptions().filter(
        (option, index) => {
          return index === nextHighlightedOptionIndex
        },
      )[0]

      this.setState(
        {
          highlightedOption:
            nextHighlightedOption && nextHighlightedOption.id
              ? nextHighlightedOption
              : previousHighlightedOption,
        },
        this.scrollToHighlightedOptionIfNotVisible,
      )
    } else if (keyCode === 37) {
      // left key
      const nextHighlightedOptionIndex =
        previousHighlightedOptionIndex - optionsPerColumn + 1 > 0
          ? Math.floor(previousHighlightedOptionIndex - optionsPerColumn)
          : previousHighlightedOptionIndex
      const nextHighlightedOption = this.filteredOptions().filter(
        (option, index) => {
          return index === nextHighlightedOptionIndex
        },
      )[0]

      this.setState(
        {
          highlightedOption:
            nextHighlightedOption && nextHighlightedOption.id
              ? nextHighlightedOption
              : previousHighlightedOption,
        },
        this.scrollToHighlightedOptionIfNotVisible,
      )
    } else if (keyCode === 39) {
      // right key
      const nextHighlightedOptionIndex =
        previousHighlightedOptionIndex + optionsPerColumn <
        this.filteredOptions().length
          ? Math.floor(previousHighlightedOptionIndex + optionsPerColumn)
          : this.filteredOptions().length - 1
      const nextHighlightedOption = this.filteredOptions().filter(
        (option, index) => {
          return index === nextHighlightedOptionIndex
        },
      )[0]

      this.setState(
        {
          highlightedOption:
            nextHighlightedOption && nextHighlightedOption.id
              ? nextHighlightedOption
              : previousHighlightedOption,
        },
        this.scrollToHighlightedOptionIfNotVisible,
      )
    } else if (keyCode === 13 || keyCode === 9) {
      if (isMultipleSelect) {
        onToggleOption(highlightedOption)
      } else {
        onSelect(highlightedOption)
      }
    }
  }

  scrollToHighlightedOptionIfNotVisible = () => {
    if (this.props.listRef.current) {
      const listRefElement = this.props.listRef.current
      const selectedItem = listRefElement.querySelector(
        '.dropdown__option--is-highlighted-option',
      )
      const selectedItemOffsetTopPosition = selectedItem
        ? selectedItem.offsetTop
        : 0
      const elementIsVisibleFromTop =
        selectedItemOffsetTopPosition - 48 > listRefElement.scrollTop
      const elementIsVisibleFromBottom =
        selectedItemOffsetTopPosition - 32 <
        listRefElement.scrollTop + listRefElement.offsetHeight
      if (!elementIsVisibleFromTop) {
        listRefElement.scrollTop = selectedItemOffsetTopPosition - 56
      } else if (!elementIsVisibleFromBottom) {
        listRefElement.scrollTop =
          selectedItemOffsetTopPosition - listRefElement.offsetHeight - 8
      }
    }
  }

  /* end keyboard navigation */

  resetSelection = () => {
    if (this.props.resetSelectedOptions) {
      this.props.resetSelectedOptions()
    }
  }

  confirmSelection = () => {
    this.props.onSelect()
  }

  render = () => {
    const {queryFilter} = this.state
    const {
      className,
      showSearchBar,
      isMultipleSelect,
      onSearchBarFocus,
      mostPopularOptions,
      listRef,
      onClose,
    } = this.props
    const filteredOptions = this.filteredOptions()
    const noResultsFoundOption = {
      name: `${i18n.t('Components.Dropdown.noResultsFoundFor')} ${
        this.state.queryFilter
      }`,
      id: 'noResultsFound',
    }
    const filteredOptionsInColumns = this.getFilteredOptionsInColumns()
    const optionsSelectedCopy = this.getOptionsSelectedCopy()

    return (
      <div
        className={`dropdown ${className} ${
          showSearchBar ? 'dropdown--has-search-bar' : ''
        } ${isMultipleSelect ? 'dropdown--is-multiple-select' : ''}`}
      >
        {showSearchBar && (
          <div className={'dropdown__search-bar'}>
            <input
              className={'dropdown__search-bar-input'}
              placeholder={i18n.t('Components.Dropdown.searchPlaceholder')}
              type={'text'}
              ref={this.textInput}
              value={queryFilter}
              onChange={this.updateQueryFilter}
              onFocus={onSearchBarFocus}
            />
            <Search className={'input-with-icon__right-icon'} />
            {isMultipleSelect && (
              <Close className={'input-with-close-icon'} onClick={onClose} />
            )}
          </div>
        )}
        {mostPopularOptions && mostPopularOptions.length > 0 && (
          <div className={'dropdown__most-popular'}>
            <span className={'dropdown__most-popular-label'}>
              {i18n.t('Components.Dropdown.mostPopularLabel')}
            </span>
            {mostPopularOptions &&
              mostPopularOptions.map(this.renderMostPopularOption)}
          </div>
        )}
        {isMultipleSelect ? (
          <div className={'dropdown__columns'} ref={listRef}>
            {showSearchBar && filteredOptions.length === 0 && (
              <div className={'dropdown__no-results-found-wrapper'}>
                {this.renderOption(noResultsFoundOption, 0)}
              </div>
            )}
            {filteredOptionsInColumns.map((optionsColumn, key) => (
              <ul key={key} className={'dropdown__list'}>
                {optionsColumn.map(this.renderOption)}
              </ul>
            ))}
          </div>
        ) : (
          <ul className={'dropdown__list'} ref={listRef}>
            {filteredOptions.map(this.renderOption)}
            {showSearchBar &&
              filteredOptions.length === 0 &&
              this.renderOption(noResultsFoundOption, 0)}
          </ul>
        )}
        {isMultipleSelect && (
          <div className={'dropdown__footer'}>
            <span className={'dropdown__footer-copy'}>
              {optionsSelectedCopy}
            </span>
            <button
              onMouseDown={this.resetSelection}
              className={'button--secondary button--compact'}
            >
              {i18n.t('Components.Dropdown.resetAllButton')}
            </button>
            <button
              onMouseDown={this.confirmSelection}
              className={'button--compact'}
            >
              {i18n.t('Components.Dropdown.doneButton')}
            </button>
          </div>
        )}
      </div>
    )
  }
}
